import axios from 'axios'

// Admin-only feedback endpoints (x-api-key attached globally by axiosConfig.js).
// -> { items, currentPage, totalPages, totalItems, hasMore }
export const getFeedbacks = async (page = 0, pageSize = 50, type = '', status = '') => {
  const params = { page, pageSize }
  if (type) params.type = type
  if (status) params.status = status
  const { data } = await axios.get('/api/feedback', { params })
  return data
}

// patch = { status?, adminNote? }
export const updateFeedback = async (id, patch) => {
  const { data } = await axios.patch(`/api/feedback/${encodeURIComponent(id)}`, patch)
  return data
}

// Also deletes the R2 screenshots server-side.
export const deleteFeedback = async (id) => {
  const { data } = await axios.delete(`/api/feedback/${encodeURIComponent(id)}`)
  return data
}
